import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { Category } from '../_models/category';
import { FormItem } from '../_models/formitem';
import { FullParcel } from '../_models/parcel';
import { AssessorForm, SignexLInk } from '../_models/assessorForm';
import { ContactGeneral } from '../_models/contactGeneral';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { tap, filter, map } from 'rxjs/operators';
import {Observable, pipe} from 'rxjs';
import { Addresses } from '../_models/address';
import { Report } from '../_models/report';
import { News } from '../_models/news';
import { GoogleAnalyticsService } from './GoogleAnalytics.service';
import { timeout } from 'rxjs/operators';
import {SendDocumentResponse} from '../forms/file-online-v2/models/api/SendDocumentResponse';
import {AmpUserInfo, AmpUserInfoPayload} from '../forms/file-online-v2/models/AmpUserInfo';
import {AttachmentDto} from '../forms/file-online-v2/models/AttachmentDto';
import {PingDocScanResponse} from '../forms/file-online-v2/models/api/PingDocScanResponse';
import {FormFAQ} from '../forms/file-online-v2/models/api/FormFAQ';
import {environment} from '../../environments/environment';
import {FormDetail} from '../forms/file-online-v2/models/api/Form';
import {LevelTwoFormData} from '../_models/LevelTwoFormData';
import {SubmissionEvent} from '../forms/file-online-v2/models/SubmissionEvent';
import {ConfigOption} from "../_models/ConfigOption";
import {ParcelInfoDataWarehouse} from "../_models/ParcelInfoDataWarehouse";
import MncStatus from "../_models/MncStatus";

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  // baseUrl = "https://assessorpstst.lacounty.gov/api/"
  // baseUrl = "https://assessorpsdev.lacounty.gov/api/"
  //baseUrl = "https://assessoradev.lacounty.gov/api/"
  //  baseUrl = "https://assessorqa.lacounty.gov/api/"
  // baseUrl = "https://assessor.lacounty.gov/api/"
  // baseUrl = "https://localhost:5001/api/"
  baseUrl: string;

  myMap = new Map<string, string>();



  currentDomain: string;
  pdfServiceDomain = 'https://pdffillqa.assessor.lacounty.gov';


  constructor(private http: HttpClient, private google: GoogleAnalyticsService) {

    this.currentDomain = window.location.host;

    switch (this.currentDomain) {
      case 'assessor.lacounty.gov':
        this.pdfServiceDomain = 'https://pdffill.assessor.lacounty.gov';
        break;
      case 'localhost:4200':
        this.currentDomain = 'localhost:5001';
        break;
    }

    this.baseUrl = 'https://' + this.currentDomain + '/api/';
  }

  isQA(): boolean {
    return this.currentDomain === 'assessorqa.lacounty.gov';
  }
  isProd(): boolean {
    return this.currentDomain === 'assessor.lacounty.gov';
  }

  getEnvironment() {
    this.myMap.set('assessor.lacounty.gov', '');
    this.myMap.set('localhost:5001', '');
    this.myMap.set('assessorqa.lacounty.gov', 'stg');
    this.myMap.set('assessorpstst.lacounty.gov', 'pstst');
    this.myMap.set('assessorate2.lacounty.gov', 'ate1');
    this.myMap.set('assessorate3.lacounty.gov', 'ate1');

    return(this.myMap.get(this.currentDomain))

  }

  translate(msg: string, lang: string) {
    let params = new HttpParams();
    params = params.append('msg', msg)
    params = params.append('lang', lang)

    return this.http.get<TranslatedMessage>(this.baseUrl + 'Level2/translate', {
      headers: this.getHeaders(),
      params: params
    })
}

  search(msg: string) {
    let params = new HttpParams();
    params = params.append('query', msg)

    return this.http.get<SearchQuery[]>(this.baseUrl + 'Level2/search', {
      headers: this.getHeaders(),
      params: params
    })
  }

  getFaqByPage(id: string) {
    let params = new HttpParams();
    params = params.append('Id', id);

    return this.http.get(this.baseUrl + 'Level2/faqbypage', {
      headers: this.getHeaders(),
      params: params
    });
  }

  getFormByPage(id: string) {
    let params = new HttpParams();
    params = params.append('Id', id);

    return this.http.get(this.baseUrl + 'Level2/page/forms', {
      headers: this.getHeaders(),
      params: params
    });
  }

  getCategories() {
    let params = new HttpParams();
    return this.http.get<Category[]>(this.baseUrl + 'Form/categories', {
      headers: this.getHeaders()
    })
  }

  getNews() {
    let params = new HttpParams();
    return this.http.get<News[]>(this.baseUrl + 'Level2/news', {
      headers: this.getHeaders()
    })
  }

  getFacts(id: string) {
    let params = new HttpParams();
    params = params.append('Id', id);

    return this.http.get<FactSheet[]>(this.baseUrl + 'Level2/facts', {
      params: params
    })
  }

  getPage(page: string) {
    let params = new HttpParams();
    params = params.append('page', page)
    return this.http.get<Page>(this.baseUrl + 'Level2/page', {
      params: params
    })
  }
  getForms() {
    let params = new HttpParams();
    return this.http.get<FormItem[]>(this.baseUrl + 'Form/allforms', {
      headers: this.getHeaders()
    })
  }
  getRoll() {
    let params = new HttpParams();
    return this.http.get<Report[]>(this.baseUrl + 'Level2/rolls', {
      headers: this.getHeaders()
    })
  }
  getReports() {
    let params = new HttpParams();
    return this.http.get<Report[]>(this.baseUrl + 'Level2/annualReport', {
      headers: this.getHeaders()
    })
  }

  getTrendYears() {
    return this.http.get(this.baseUrl + 'Level2/page/TrendFactors/Years');
  }

  getParcel(ain: any) {
    let params = new HttpParams();
    params = params.append('ain', ain);
    return this.http.get<FullParcel>('https://portal.assessor.lacounty.gov/api/parceldetail', {
      params: params
    });
  }
  getAddress(address: any) {
    let params = new HttpParams();
    params = params.append('search', address);
    return this.http.get<Addresses>('https://portal.assessor.lacounty.gov/api/search', {
      params: params
    });
  }

  getTrendFactors(id: any) {
    let params = new HttpParams();
    params = params.append('year', id);

    return this.http.get(this.baseUrl + 'Level2/page/TrendFactors', {
      headers: this.getHeaders(),
      params: params
    });
  }

  sendForm(contactForm:any, formType: string)
  {
    this
      .google
      .formEmitter("Contact Forms", formType);
    return this.http.post<any>(this.baseUrl + 'Contact/assessor/'+ formType, contactForm)
  }

  sendAttachment(form: any)
  {
    return this.http.post<any>(this.baseUrl + 'efile/AddAttachment', form)
  }

  sendDocument(contactForm:any)
  {
    return this.http.post<any>(this.baseUrl + 'efile/SendDocuments', contactForm)
  }

  sendMultiDocument(contactForm:any)
  {
    return this.http.post<any>(this.baseUrl + 'efile/SendMultiDocuments', contactForm)
  }

  accessLink(id: string) {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.get<SignexLInk>(this.baseUrl + 'efile/accessLink', {
      params: params
    })
  }

  getHeaders() {
    const lang = localStorage.getItem('lang') || 'en';

    return new HttpHeaders({
      'Accept-Language': lang
    });
  }

  validate(ain: string, pin: string, id: number) {
    let params = new HttpParams();
    params = params.append('ain', ain);
    params = params.append('pin', pin);
    params = params.append('id', id.toString());
    return this.http.get<any>(this.baseUrl + 'efile/validate', {
      params: params
    });
  }

  getFaq(id: string) {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.get<any>(this.baseUrl + 'efile/faq', {
      params: params
    });
  }


  getAssessorFormStatus(email: string) {
    let params = new HttpParams();
    params = params.append('email', email);
    return this.http.get<AssessorForm[]>(this.baseUrl + 'efile/records', {
      params: params
    });
  }

  eFile() {
    return this.http.get(this.baseUrl + 'efile/getuserinfo', { observe: 'response' })
  }

  ePing(): Observable<HttpResponse<any>> {
    let currentDomain = window.location.host;

    if (currentDomain === 'localhost:4200'){
      currentDomain = 'localhost:5001';
    }

    const baseUrl = 'https://' + currentDomain;
    return this.http.get( baseUrl + '/PingDocScanIntakeService', { observe: 'response' })
      .pipe(
        timeout(5000) // Timeout set to 5 seconds (5000 milliseconds)
      );
  }

  // E-FILE 2.0
  getEFileUrl(formNumber: string): string {
    return '/efile/submit?id=' + formNumber.replace(/\s/g, '').replace(/\//g, '-');
  }

  isAds820(item: FormDetail): boolean {
    return item.formNumber === 'ADS-820' || item.formNumber === 'ADS-820.2';
  }
  getFormFaq(id: string): Observable<FormFAQ> {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.get<FormFAQ>(this.baseUrl + 'efile/faq', { params });
  }

  getForm(formNumber: string): Observable<FormDetail> {
    let params = new HttpParams();
    params = params.append('formNumber', formNumber);
    return this.http.get<FormDetail>(this.baseUrl + 'Form/formbynumber', { params });
  }

  submitForm(webFormSubmissionJson: string, attachments: AttachmentDto[]): Observable<SendDocumentResponse>
  {
    return this.submitFormHelper(webFormSubmissionJson, attachments, 'efile/submit');
  }

  submitAdsForm(webFormSubmissionJson: string, attachments: AttachmentDto[]): Observable<SendDocumentResponse>
  {
    return this.submitFormHelper(webFormSubmissionJson, attachments, 'ads/SubmitDisasterForm');
  }

  submitFormHelper(webFormSubmissionJson: string, attachments: AttachmentDto[], apiRoute: string): Observable<SendDocumentResponse>
  {
    const formData = new FormData();
    formData.append('submission', webFormSubmissionJson);

    attachments.forEach((dto: AttachmentDto, index: number) => {
      formData.append(`files[${index}].isPii`, dto.isPii.toString());
      formData.append(`files[${index}].file`, dto.file, dto.file.name);
    });

    return this.http.post<SendDocumentResponse>(`${this.baseUrl}${apiRoute}`, formData);
  }

  secondSignerAccessLink(docId: string): Observable<string> {
    let params = new HttpParams();
    params = params.append('docId', docId);
    return this.http.get<string>(this.baseUrl + 'Sign/secondSignerAccessLink', { params });
  }

  userInfo(): Observable<AmpUserInfoPayload[]>
  {
    return this.http.get<AmpUserInfoPayload[]>(this.baseUrl + 'efile/getuserinfo');
  }

  siteSettings(): Observable<ConfigOption[]>
  {
    return this.http.get<ConfigOption[]>(this.baseUrl + 'SiteConfig/config');
  }

  async getAmpUserInfo(): Promise<[AmpUserInfo, AmpUserInfoPayload[]]> {
    const data = await this.userInfo().toPromise();

    if (!data) {
      return [null, null];
    }

    if (environment.fakeAmpFirst.length !== 0) {
      data[0].value = environment.fakeAmpId;
      data[1].value = environment.fakeAmpLast;
      data[2].value = environment.fakeAmpMiddle;
      data[3].value = environment.fakeAmpFirst;
      data[4].value = environment.fakeAmpPhone;
    }

    return [new AmpUserInfo(
      data[0].value,
      data[1].value,
      data[2].value,
      data[3].value,
      data[4].value,
    ), data];
  }

  getAmpStatus(): Observable<PingDocScanResponse | HttpResponse<PingDocScanResponse>> {
    let currentDomain = window.location.host;

    if (currentDomain === 'localhost:4200'){
      currentDomain = 'localhost:5001';
    }

    const baseUrl = 'https://' + currentDomain;
    return this.http.get<PingDocScanResponse>( baseUrl + '/PingDocScanIntakeService', { observe: 'response' })
      .pipe(
        timeout(5000) // Timeout set to 5 seconds (5000 milliseconds)
      );
  }

  getRenderedPdf(json: string): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json'});
    return this.http.post(`${this.baseUrl}pdf/fill`, json, { headers, responseType: 'blob'});
  }

  manuallyKickOffWorkUnit(clientId: number, action: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded'});
    const body = new HttpParams().set('clientId', String(clientId)).set('action', action);
    return this.http.post<any>(this.baseUrl + 'sign/manualKickOff', body.toString(), { headers });
  }

  getFormByPageNew(id: string): Observable<LevelTwoFormData[]> {
    let params = new HttpParams();
    params = params.append('Id', id);

    return this.http.get<LevelTwoFormData[]>(this.baseUrl + 'Level2/page/forms', {
      headers: this.getHeaders(),  params
    });
  }

  notifySubmissionError(event: SubmissionEvent): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json'});
    const body = JSON.stringify(event);
    return this.http.post<any>(this.baseUrl + 'metrics/log', body, { headers });
  }

  getParcelInfo(ain: string): Observable<ParcelInfoDataWarehouse> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json'});
    const params = new HttpParams().append('assessment', ain);
    return this.http.get<ParcelInfoDataWarehouse>(this.baseUrl + 'DataWarehouse/ParcelInfo', {
      params,
      headers
    });
  }

  getAllForms(): Observable<FormDetail[]> {
    return this.http.get<FormDetail[]>(this.baseUrl + 'Form/allforms', {
      headers: this.getHeaders()
    });
  }

  getMncStatus(ain: string): Observable<MncStatus> {
    const params = new HttpParams().append('assessment', ain);
    return this.http.get<MncStatus>(this.baseUrl + 'DataWarehouse/MncStatus', {
      params
    });
  }
}

export function toFormData<T>( formValue: any ) {
  const formData = new FormData();
  // console.log(formValue);
  for ( const key of Object.keys(formValue) ) {
    const value = formValue[key];
    console.log(key + ' ' + value)
    formData.append(key, value);
  }

  return formData;
}

export function markAllAsDirty( form: UntypedFormGroup ) {
  for ( const control of Object.keys(form.controls) ) {
    form.controls[control].markAsDirty();
  }
}

export function requiredFileSize( type: number ) {
  return function (control: UntypedFormControl ) {
    const file = control.value;

    if ( file ) {
      // console.log(file.size);
      if(file.size > type) {
        return {
          requiredFileSize: true
        }
      }
      return null;
    }
    return null;
  };
}

export function requiredFileType( type: string ) {
  return function ( control: UntypedFormControl ) {
    const file = control.value;
    // console.log(file);
    if ( file ) {

      var re = /(?:\.([^.]+))?$/;

      const extension = re.exec(file.name)[1].toLowerCase();

      if ( "pdf" == extension.toLowerCase() ) {
        console.log('pdf')
        return null;
      }

      if ( "docx" == extension.toLowerCase() ) {
        console.log('docx')
        return null;
      }



      return {
        requiredFileType: true
      };
    }

    return null;
  };
}

export function uploadProgress<T>( cb: ( progress: number ) => void ) {
  return tap(( event: HttpEvent<T> ) => {
    if ( event.type === HttpEventType.UploadProgress ) {
      cb(Math.round((100 * event.loaded) / event.total));
    }
  });
}

export function toResponseBody<T>() {
  return pipe(
    filter(( event: HttpEvent<T> ) => event.type === HttpEventType.Response),
    map(( res: HttpResponse<T> ) => res.body)
  );
}

export interface TranslatedMessage {
  message: string
}

export interface SearchQuery {
  url: string,
  title: string,
  snippet: string,
  rank: any;
  realTitle: string
}

export interface Page {
  id: number,
  pageName: string,
  fact: boolean,
  file: boolean,
  faq: boolean
}

export interface FactSheet {
  id: number,
  fileUrl: string,
  title: string,
  description: string,
  languageCode: string,
  active: boolean
}
